'use client';
import React from 'react';
import clsx from 'clsx';
import { Box, Link } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import ParallaxBlock from '@components/ParallaxBlock';
import AldarLogo from '@components/AldarLogo';
import DynamicScrollHeader from '@components/DynamicScrollHeader';
import DynamicLogo from '@components/DynamicLogo';
import DynamicHideBlock from '@components/DynamicHideBlock';
import { LanguageDropdown } from '@components/LanguageDropdown';

import cn from './style.module.scss';

export default function OgamiHeader(props: MarketingPageComponentProps) {
  const headerSection = props?.locale?.section?.find(
    (section: any) => section.type === 'header' && section.enabled
  );
  if (!headerSection) return null;
  return (
    <DynamicScrollHeader
      headerClassName={cn.ogamiHeaderWrapper}
      scrolledClassName={cn.ogamiHeaderFixed}
    >
      <Box className={cn.ogamiHeaderInner}>
        <ParallaxBlock
          className={cn.ogamiHeaderBlock}
          animationType="zoomIn"
          animationDuration={500}
        >
          <Box className={cn.ogamiHeaderControls}>
            <DynamicHideBlock data={headerSection?.ogamiHeaderLanguage}>
              <Box className={cn.ogamiHeaderDropdown}>
                <LanguageDropdown
                  className={cn.ogamiHeaderLanguage}
                  options={props.langOptions || []}
                />
              </Box>
            </DynamicHideBlock>
          </Box>

          <Box className={cn.ogamiHeaderBrand}>
            <Box component="picture" className={cn.ogamiHeaderLogoElement}>
              <DynamicHideBlock data={headerSection.ogamiHeaderLogo}>
                <Box className={cn.ogamiHeaderLogo}>
                  <DynamicLogo
                    logoImage={headerSection.ogamiSodic}
                    alt="Ogami Logo"
                  />
                </Box>
              </DynamicHideBlock>
            </Box>

            <Box component="picture" className={cn.ogamiHeaderLogoElement}>
              <DynamicHideBlock data={headerSection?.ogamiAldarLogo}>
                <Box className={cn.ogamiHeaderAldar}>
                  <Link
                    className={cn.ogamiHeaderAldarLink}
                    href="https://www.aldar.com/properties/en"
                    target="_blank" rel="noopener noreferrer"
                  >
                    <AldarLogo color="white" />
                  </Link>
                </Box>
              </DynamicHideBlock>
            </Box>
          </Box>
        </ParallaxBlock>
      </Box>
    </DynamicScrollHeader>
  );
}
